import { Box, Grid, Stack, SxProps, Theme, Typography, TypographyVariant } from "@mui/material";
import { JSX, PropsWithChildren } from "react";
import HorizontalFill from "../../../../components/HorizontalFill.tsx";

interface Props {
  caption: string | JSX.Element;
  captionVariant?: TypographyVariant;
  actions?: JSX.Element;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
}

export const PartContainer = (props: PropsWithChildren<Props>) => {
  const { children, caption, captionVariant, actions, sx, containerSx } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        borderRight: "1px solid #E0E0E0",
        py: "1.3rem",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          ...containerSx,
        }}
      >
        <Grid container alignItems={"center"} width={"100%"}>
          <Typography variant={captionVariant ?? "h6"}>{caption}</Typography>
          <HorizontalFill />
          <Stack>{actions}</Stack>
        </Grid>
        {children}
      </Box>
    </Box>
  );
};

export default PartContainer;
